module.exports = "/static/assets/5e4aba26bb06bcc0ae1357d1cfdfd678.gif";